import React from 'react';
import { Card, CardText, CardTitle } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';

import BoxCountChart from '~/widgets/BoxCountChart';
import ProductionQueue from '~/widgets/ProductionQueue';
import ProductionQueueDistributor from '~/widgets/ProductionQueueDistributor';
import UserBoxStats from '~/widgets/UserBoxStats';

import Styles from './index.scss';

class Dashboard extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const user = this.props.user.toJS();
    if (!user) {
      return <div>Loading</div>;
    }
    return (
      <div className={Styles.content}>
        <div className={`${Styles.gridBox} ${Styles.userChartsBox}`}>
          <Card>
            <CardTitle title={`Welcome ${user.name}`} />
          </Card>
        </div>
        {user.level <= 1000 && (
          <div>
            <div className={Styles.gridBox}>
              <Card>
                <CardText>
                  <BoxCountChart.widget indata={{ orderStatus: 'Distributor', title: 'Distributor' }} />
                </CardText>
              </Card>
            </div>
            <div className={Styles.gridBox}>
              <Card>
                <CardText>
                  <BoxCountChart.widget indata={{ orderStatus: 'Todo', title: 'Processing' }} />
                </CardText>
              </Card>
            </div>
            <div className={`${Styles.gridBox} ${Styles.userChartsBox}`}>
              <Card>
                <CardText>
                  <UserBoxStats.widget indata={{ showDateFields: true, title: 'User statistics' }} />
                </CardText>
              </Card>
            </div>
          </div>
        )}
        {user.level <= 1500 && (
          <div>
            <div className={`${Styles.gridBox} ${Styles.userChartsBox}`}>
              <Card>
                <CardText>
                  <ProductionQueueDistributor.widget indata={{ title: 'Distributor list', expandable: true }} />
                </CardText>
              </Card>
            </div>
            <div className={`${Styles.gridBox} ${Styles.userChartsBox}`}>
              <Card>
                <CardText>
                  <ProductionQueue.widget indata={{ orderStatus: 'Todo', title: 'Processing list', expandable: true }} />
                </CardText>
              </Card>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.getIn(['user', 'self'], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./app/pages/Index/index.js